import { convertToUtc } from '@openeducation/oe-it-utils';
import { format } from 'date-fns';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

export function arrayParseDate(dateArray: number[]): Date | undefined {
  if (!dateArray || !dateArray.length) {
    return;
  }

  const [year, month, day, hour = 0, minute = 0] = dateArray;
  return new Date(year, month - 1, day, hour, minute);
}

export function dateArrayToString(dateArray: number[], stringFormat: string) {
  if (!stringFormat) {
    return '';
  }

  const date = arrayParseDate(dateArray);
  if (!date) {
    return '';
  }
  return format(date, stringFormat);
}

export function dateArrayToUtc(dateArray: number[], timeZone: string) {
  const date = dateArrayToString(dateArray, 'yyyy-MM-dd HH:mm:ss');

  return zonedTimeToUtc(date, timeZone);
}

export function dateArrayToReservationString(dateArray: number[]) {
  const parsedDate = arrayParseDate(dateArray);
  if (!parsedDate) {
    return '';
  }
  return dateToReservationString(parsedDate);
}

export function dateToReservationString(date: Date, timeZone?: string) {
  if (!date) {
    return '';
  }

  function dateReservationStringNoTz(date: Date) {
    const formattedDate = format(date, 'yyyy-MM-dd'); // 2014-10-25 06:46:20-04:00
    const formattedTime = format(date, 'HH:mm:ss'); // 2014-10-25 06:46:20-04:00

    return [formattedDate, formattedTime];
  }

  function dateReservationStringTz(date: Date, timeZone: string) {
    const dateInTimeZone = formatInTimeZone(date, timeZone, 'yyyy-MM-dd'); // 2014-10-25 06:46:20-04:00
    const timeInTimeZone = formatInTimeZone(date, timeZone, 'HH:mm:ss'); // 2014-10-25 06:46:20-04:00

    return [dateInTimeZone, timeInTimeZone];
  }

  let formattedDate, formattedTime;
  if (timeZone) {
    [formattedDate, formattedTime] = dateReservationStringTz(date, timeZone);
  } else {
    [formattedDate, formattedTime] = dateReservationStringNoTz(date);
  }

  return `${formattedDate}T${formattedTime}`;
}

export function dateArrayToDate(dateArray: number[]) {
  if (!dateArray || !dateArray.length) {
    return null;
  }
  const [year, month, day, hour = 0, minute = 0] = dateArray;
  return new Date(year, month - 1, day, hour, minute);
}

export function convertArrayToDateUtc(dateArray: number[]) {
  if (!dateArray || !dateArray.length) {
    return null;
  }
  const [year, month, day, hour = 0, minute = 0] = dateArray;
  return convertToUtc(new Date(year, month - 1, day, hour, minute));
}

export function dateToDateArray(date: Date) {
  return [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
  ];
}

export function dateToLocalDateArray(date: Date) {
  return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
}

export const checkIfDatesAreDifferent = (
  date1?: number[] | null,
  date2?: number[] | null
) => {
  if (!date1 && !date2) {
    return false;
  } else if (date1 && date2) {
    const dateTime1 = dateArrayToDate(date1);
    const dateTime2 = dateArrayToDate(date2);
    return dateTime1?.getTime() !== dateTime2?.getTime();
  }
  return false;
};
